module.exports = __webpack_public_path__ + "static/media/logo.929d0d31.svg";